module.exports = __webpack_public_path__ + "static/media/check-circle-copy.975098b5.svg";